import React, { useMemo } from 'react';
import { FCX } from '@datassential/platform-ui-lib';
import cn from 'classnames';
import {
    CLOSURES_COLOR,
    OPENINGS_COLOR,
    TOTAL_ACTIVE_COLOR,
} from './RestaurantOpeningsClosings.constants';
import { useOpeningsClosingsFilters } from './context/OpeningsClosingsFilterContext';
import './OpeningsClosingsLegend.scss';

interface LegendItemProps {
    color: string;
    label: string;
    subLabel: string | undefined;
}

const LegendItem = ({ color, label, subLabel }: LegendItemProps) => (
    <div className="OpeningsClosingsLegend__item">
        <span
            className="OpeningsClosingsLegend__dot"
            style={{ background: color }}
            aria-hidden="true"
        />
        <div className="OpeningsClosingsLegend__text">
            <span className="OpeningsClosingsLegend__name">{label}</span>
            {subLabel !== undefined && (
                <span className="OpeningsClosingsLegend__sublabel">{subLabel}</span>
            )}
        </div>
    </div>
);

const OpeningsClosingsLegend: FCX = ({ className }) => {
    const { lastMonth } = useOpeningsClosingsFilters();

    const closuresSubLabel = useMemo(
        () => lastMonth ? `${lastMonth.month}: ${lastMonth.closures.toLocaleString()} units` : undefined,
        [lastMonth],
    );
    const openingsSubLabel = useMemo(
        () => lastMonth ? `${lastMonth.month}: ${lastMonth.openings.toLocaleString()} units` : undefined,
        [lastMonth],
    );
    const totalActiveSubLabel = useMemo(
        () => lastMonth ? `${lastMonth.month}: ${lastMonth.totalActive.toLocaleString()} units` : undefined,
        [lastMonth],
    );

    return (
        <div className={cn('OpeningsClosingsLegend', className)}>
            <div className="OpeningsClosingsLegend__left">
                <LegendItem color={CLOSURES_COLOR} label="Permanent Closures" subLabel={closuresSubLabel} />
                <LegendItem color={OPENINGS_COLOR} label="New Openings" subLabel={openingsSubLabel} />
            </div>
            <div className="OpeningsClosingsLegend__right">
                <LegendItem color={TOTAL_ACTIVE_COLOR} label="Total Active Restaurants" subLabel={totalActiveSubLabel} />
            </div>
        </div>
    );
};

export default OpeningsClosingsLegend;
